import { render, staticRenderFns } from "./language-switch.vue?vue&type=template&id=1c79ec09&"
import script from "./language-switch.vue?vue&type=script&lang=js&"
export * from "./language-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports